import { useParams } from 'react-router-dom';
import { useGetQRImageQuery, useGetOrderByIdQuery, useGetBusinessByIdQuery } from '../store';
import LoadingLottie from '../components/atoms/LoadingLottie';
import { parseFriendlyDate } from '../utils/dates';

const QrDisplay = () => {
  const { order_id: orderId } = useParams();
  const { data: qrImageData, isLoading } = useGetQRImageQuery({
    orderId: orderId || '',
  });
  const { data: order } = useGetOrderByIdQuery({ orderId: orderId || '' });
  const { data: business } = useGetBusinessByIdQuery(order?.event.business_id || '', { skip: !order?.event.business_id });

  if (isLoading) {
    return <LoadingLottie />;
  }

  if (!order) {
    return <div className='flex flex-col justify-center items-center text-center my-6 min-h-screen glass-surface'>
      <h1 className='text-2xl'>La entrada fue eliminada o no fue encontrada</h1>
    </div>;
  }

  return (
    <div className="flex flex-col justify-center my-6 min-h-screen glass-surface">

      {business?.logo && <img src={business?.logo} alt="Banner" className="max-w-xs object-contain mx-auto mb-6" />}
      <h1 className="text-4xl font-bold text-center text-text-primary">{order?.event.name}</h1>
      <div className="text-2xl font-light text-center mt-4 text-text-primary">{parseFriendlyDate(order?.event.date || '', true, true)}</div>
      <div className="text-2xl font-light text-center mt-2 text-text-primary">Cantidad: {order?.items.length}</div>
      {qrImageData?.qr_base64.map((qr, index) => (
        <div>
          <img
            key={index}
            src={`data:image/png;base64,${qr}`}
            alt="QR Code"
            className="border border-border-primary rounded-lg shadow-md mx-auto my-20"
            style={{ transform: 'scale(1.3)', maxWidth: '65vw' }}
          />
          <div className="text-4xl font-bold text-center text-text-primary">{order?.items[index].ticket.name}</div>
          <div className="text-xl font-light text-center mt-2 text-text-primary">{order?.items[index].name} {order?.items[index].last_name}</div>
          <div className="text-xl font-light text-center mt-2 text-text-primary">{order?.items[index].person_id}</div>
          <div className="text-xl font-light text-center mt-2 text-text-primary">{order?.items[index].event_seat?.name}</div>
        </div>
      ))}
      {/* <footer className='relative before:absolute before:top-0 before:left-0 before:right-0 before:h-1 before:bg-gradient-to-r before:from-black before:via-gray-600 before:to-gray-400 mt-32'>
        <div className='flex justify-end items-center gap-2 mt-2'>
          <img src="/event-polls.svg" alt="" className='w-9 h-9 object-contain grayscale' />
          <img src="/event-referrals.svg" alt="" className='w-8 h-8 object-contain grayscale' />
          <img src="/event-links.svg" alt="" className='w-8 h-8 object-contain grayscale' />
          <img src="/event-svg-1.svg" alt="" className='w-8 h-8 object-contain grayscale' />
          <img src="/event-svg-2.svg" alt="" className='w-8 h-8 object-contain grayscale' />
        </div>
      </footer> */}
    </div>
  );
};

export default QrDisplay;
